module.exports = __webpack_public_path__ + "images/home/product/features-search-b5d71541622c97515cf1d21e9441d6d7.png";